export default {
  scorecard: {
    title: 'Tarjeta de puntaje',
    content: 'Contenido',
    award: 'El premio ESG',
  },
  list_table_filter: {
    table_buyer_company_name: 'Empresas compradoras',
    table_question_group_name: 'Cuestionario',
    table_status: 'Estado',
    table_issue_at: 'Fecha de emisión',
    table_sustaina_rate: 'Calificación ESG',
    table_esg_score: 'Puntaje ESG',
    table_operation: 'Operación',
    displayed_items_number: 'Mostrar {start}〜{end} / {total} empresas',
    displayed_items_number_empty: 'Mostrar 0 / 0 empresas',
    no_data_display: 'No hay datos disponibles',
    csv_modal_title: 'Seleccione los elementos que desea exportar en CSV',
    csv_modal_answer_status_title: 'Estado de la respuesta',
    csv_modal_answer_status_text: 'Lista de estados de respuestas de los proveedores de exportación.',
    csv_modal_answer_title: 'Respuesta (1 archivo por 500 empresas)',
    csv_modal_answer_title_by_individual_company: 'Respuesta (1 archivo por empresa)',
    csv_modal_answer_text: 'Las respuestas de los proveedores se mostrarán en 1 archivo por cada 500 empresas.',
    csv_modal_answer_text_by_individual_company: 'Las respuestas de los proveedores se mostrarán en 1 archivo por cada empresa.',
    csv_modal_score_title: 'Puntuación',
    csv_modal_score_text: 'Exportar calificaciones y puntuaciones de los proveedores',
    csv_modal_answer_heading: 'Encabezado',
    csv_modal_answer_heading_supplier: 'Proveedor',
    csv_modal_answer_heading_question: 'Pregunta',
    csv_modal_answer_additional: 'Elemento adicional',
    csv_modal_answer_additional_note: 'Nota',
    csv_modal_answer_additional_file: 'Nombre de archivo adjunto',
    csv_modal_cautionary_note_title: 'Aviso',
    csv_modal_cautionary_note_content: '・El archivo de salida incluye «estado de la respuesta», «respuesta» y «puntuación» para {questionGroupName}.\n・Para el «estado de la respuesta» se incluyen todas las empresas registradas, independientemente del estado de su respuesta en la encuesta.\n・Para «respuesta» y «puntación», las empresas con una respuesta en estado de «En progreso» no se incluyen en el archivo de salida.\n・El número máximo de empresas que se pueden mostrar en un solo archivo CSV para «respuesta» y «puntuación» es  de 1000.\n・El archivo CSV se enviará a la dirección de correo electrónico de la cuenta que está conectada actualmente.',
    csv_modal_sent_mail_section_one: 'Su solicitud de exportación a CSV ha sido aceptada.',
    csv_modal_sent_mail_section_two: 'Espere un momento hasta que le enviemos a su dirección de correo electrónico un mensaje con la URL para descargar el CSV.',
    csv_modal_sent_mail_section_three: 'Si no recibe un correo electrónico dentro de 30 minutos, favor de intentarlo nuevamente.',
  },
  overall_score_section: {
    card_title: 'Contenido de la encuesta',
    score: 'Puntuación',
    esg_score: 'Puntaje ESG',
    esg_rating: 'Calificación ESG',
    esg_score_tip: 'La puntuación ESG es una evaluación de las actividades ESG de su empresa. Se calcula en función de sus respuestas a la encuesta ASUENE ESG.',
    esg_rating_tip: 'La calificación ESG es una evaluación absoluta del nivel de las actividades ESG de su empresa categorizada en una escala de siete puntos de AAA a CCC basada en su puntuación ESG.',
    evaluator_advice_title: 'Comentario de la evaluación',
    list_header_buyer_company_name: 'Empresas compradoras',
    list_header_supplier_company_name: 'Proveedor',
    list_header_question: '@:common.upload.title',
    list_header_create_at: 'Fecha de emisión',
    list_header_deadline: 'Periodo de validez',
    list_header_industry: 'Industria',
    list_header_company_scale: 'Número de empleados',
    download_csv: 'Exportar CSV',
    download_pdf: 'Exportar PDF',
    csv_title_for_buyer: 'Respuestas del cuestionario ESG de ASUENE',
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'Descargar respuestas en csv.',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'Descargar respuestas en pdf.',
    scorecard_pdf: 'Tarjeta de puntaje(PDF)',
    download_scorecard_pdf_description: 'Descargar puntuación en pdf.',
    feedback: 'Información de la evaluación',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'El documento se descargará en PDF.',
    award_medal_svg: 'El premio ESG(SVG)',
    download_award_medal_svg_description: 'Descargar como imagen SVG',
    award_medal_png: 'El premio ESG(PNG)',
    download_award_medal_png_description: 'Descargar como imagen PNG',
    pdf_modal_sent_mail_section_one: 'Su solicitud de exportación a PDF ha sido aceptada.',
    pdf_modal_sent_mail_section_two: 'Espere un momento hasta que le enviemos a su dirección de correo electrónico un mensaje con la URL para descargar el PDF.',
    pdf_modal_sent_mail_section_three: 'Si no recibe un correo electrónico dentro de 30 minutos, favor de intentarlo nuevamente.',
  },
  category_score_section: {
    card_title: 'Puntación por categoría',
    tip: 'Una puntuación de categoría es una puntuación para la categoría medioambiental, social y de gobernanza de su empresa. La ponderación de las preguntas de cada categoría varía según la empresa.',
    policy: 'Política',
    action: 'Acción',
    result: 'Resultado',
  },
  score_by_category_compared_section: {
    card_title: 'Comparación de puntuación por Categoría',
    get_score_by_category: 'Puntuación por categoría de su empresa',
    esg_evaluated_all_companies_average: 'Todas las empresas evaluadas por ASUENE ESG',
    tip: 'Esta es la puntuación media de las empresas que respondieron a la misma encuesta.',
  },
  strengths_advice_section: {
    card_title: 'Fortaleza, consejo',
    strong_point: 'Fortaleza',
    advice: 'mejora',
    policies: 'Política',
    action: 'Acción',
    result: 'Resultado',
    no_results_for_this_category: 'No hay resultados para este Categoría',
    risk: 'Riesgo',
    indicator: 'Indicador',
    content: 'Contenido',
    operation: 'Operación',
  },
  preview: {
    go_back_to_scorecard: 'Volver al cuadro de mandos',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: 'Resumen de la puntuación general',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: 'Puntaje promedio:',
    category_card_score_no_score: 'No procede',
    category_card_score_earned_score: 'Su puntuación',
    category_card_details_list_title: 'Comentario de la evaluación',
    category_card_details_no_score_tip: 'Esta categoría no está incluida en la evaluación.',
    category_card_score_average_score: 'Puntuación media de todas las empresas',
    category_card_details_title: 'Resumen de la puntuación de la categoría',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: 'Este artículo no es aplicable ya que la encuesta se ha evaluado de acuerdo con la lógica del comprador.',
    buyer_evaluate_tip: 'Este artículo se ha evaluado de acuerdo con la lógica del comprador. No se ha evaluado según la lógica de puntuación de Asuene ESG.',
    answer_rejection_notification: 'Ha recibido una nueva solicitud de retiro',
    answer_rejection_modal_title: 'Devolver el envío',
    answer_rejection_modal_text: 'Devolver el comentario',
    answer_rejection_modal_content: 'La respuesta de {companyName} será devuelta. \nPor favor, escriba un comentario para el motivo de la devolución',
    answer_rejection_dialog_content: 'Su respuesta de {companyName} ha sido devuelta',
    answer_rejection_button_title: 'Devolver',
  },
}
